module.exports = __webpack_public_path__ + "static/media/brochure-adhesion.a48da990.pdf";